import $ from "jquery";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import { getImageByContentId } from "#scripts/images";
import { createGuid, renameJsonNode } from "#scripts/general_functions";
import language from "#scripts/translation";
import { calendarItem } from "#templates/modules/calendar_template";
import { addEventProcessor } from "@sentry/browser";

export const getCalendar = (options, callback) => {
	//load = 3), (from = 0), (mode = ""), (subcategory = "");
	const categoriesApiId = options.category || window.serverdata.configMeta.aim.calendar.localid;
	const calendarNameId = window.serverdata.configMeta.aim.calendar.group;

	if (options.mode === "friskus") {
		const munic = window.serverdata.configMeta.aim.calendar.friskusId || "";
		const calendarApiUrl = `https://api.friskus.com/api/ext/v2/events?municipalities%5B%5D=${munic}&page=1`;
		const options =
		{
			method: 'GET', // or 'POST', 'PUT', etc.
			headers: {
				'Content-Type': 'application/json',
				'X-API-KEY': 'rJgcohRrdHNJINO28DRcpe3LkN4Z30fISuU5ifBC'
			}
		}

		fetch(calendarApiUrl, options)
			.then((data) => data.json())
			.then((data) => {
				// mod data to mimic our sspkalender
				//data->MonthWithEvents.DaysWithEvents.Events
				//.MonthWithEvents.DaysWithEvents.Events
				// id->Id;
				renameJsonNode(data, "data.id", "data.Id");
				// // name->Name;
				renameJsonNode(data, "data.name", "data.Name");
				// // start_at->FraDato
				renameJsonNode(data, "data.start_at", "data.FraDato");
				// // Lokasjon.Adresse->address.address;
				// renameJsonNode(data, "address", "Lokasjon");

				renameJsonNode(data, "data", "FullListOfEvents");
				callback(data);
			})
			.catch((error) => console.error("Error: ", error));
	} else {
		const munic = window.serverdata.configMeta.aim.calendar.municipalities || "";
		const calendarApiUrl = `https://sspkalender.prokom.no/api/tidspunkt?Categories=${categoriesApiId}&SearchText=&DateFrom=&DateTo=&Municipalities=${munic}&Kunde=${calendarNameId}&Id=&ItemDate=&WeekDays=&List=${options.mode}&Count=&Distributor=`;
		fetch(calendarApiUrl)
			.then((data) => data.json())
			.then((data) => {
				callback(data);
			})
			.catch((error) => console.error("Error: ", error));
	}
};

export const calendarModule = (maxItems = 3, moduleTitle, mode = "", moduleLinks, category = "", design = "") => {
	let more = "";
	let content = "";
	maxItems = Number.parseInt(maxItems);

	getCalendar({ mode: mode, category: category }, (data) => {
		// extract date format from mode
		const tmpMode = mode.split("-");
		mode = tmpMode[0];

		let calendar = [];
		let nofItems = data.FullListOfEvents?.length || (data.MonthWithEvents !== null ? data.MonthWithEvents[0]?.DaysWithEvents.length : 0);
		if (nofItems === undefined) {
			nofItems = 0;
		}
		if (window.serverdata.configMeta.aim?.calendar?.hideEmptySubCalendar) {
			if (nofItems === 0) return "";
		}
		if (nofItems >= 0) {
			if ((mode === "compact" || mode === "friskus") && data.FullListOfEvents?.length > 0) {
				data.FullListOfEvents.forEach((item, index) => {
					if (index > maxItems - 1) {
						return;
					}
					dayjs.extend(updateLocale);
					dayjs.updateLocale(
						"nb",
						{
							weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
							monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
						},
						"nn",
						{
							weekdaysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
							monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
						},
					);

					const from = dayjs(item.FraDato);
					let dayPart = from.date();
					let datePart = from.format("MMM");
					if (window.serverdata.configMeta.aim.calendar.displayMode === 1) {
						dayPart = from.format("ddd");
						datePart = from.format("DD. MMM");
					}
					const adress = item?.KalenderObjekt?.Sted[0]?.Adresse || (item?.address?.name !== null ? item?.address?.name + "<br/>" : "") + item?.address?.address;
					calendar.push(
						calendarItem({
							eventId: item.Id,
							eventName: item.Name,
							itemDay: dayPart,
							itemMonth: datePart,
							eventLokasjonAdresse: adress,
							itemFrom: from.format("HH:mm"),
						}),
					);
				});
			} else if (mode !== "compact" && data.MonthWithEvents?.length > 0) {
				let index = 0;
				for (const month of data.MonthWithEvents) {
					if (index > maxItems - 1) {
						break;
					}
					for (const item of month.DaysWithEvents) {
						if (index > maxItems - 1) {
							break;
						}
						for (const event of item.Events) {
							if (index > maxItems - 1) {
								// return;
								break;
							}
							index++;
							const from = dayjs(event.FraDato);
							let dayPart = from.date();
							let datePart = from.format("MMM");
							if (window.serverdata.configMeta.aim.calendar.displayMode === 1) {
								dayPart = from.format("ddd");
								datePart = from.format("DD. MMM");
							}
							calendar.push(
								calendarItem({
									eventId: event.Id,
									eventName: event.Name,
									itemDay: dayPart, // item.Day,
									itemMonth: datePart, // item.Month,
									eventLokasjonAdresse: event.Lokasjon.Adresse,
									itemFrom: from.format("HH:mm"),
								}),
							);
						}
					}
				}
			}
			calendar = calendar.join("");
			const links = moduleLinks ? `<div class="calendar__grid">${setLinkList(moduleLinks)}</div>` : "";
			// if (nofItems > maxItems && maxItems !== 0) {
			if (mode === "friskus") {
				more = `<a href="${window.serverdata.configMeta.aim.calendar?.friskusEventUrl}" aria-label="${language("ACTIVITY_SEE_ALL")} (${language("NAV_OPEN_I_NEW")})" target="_blank" class="calendar__more__link">${language(
					"ACTIVITY_SEE_ALL",
				)} <span class="material-icons-outlined notranslate calendar__more__icon">&#xE89E;</span></a>`;
			} else {
				more = `<a href="/kalenderliste" class="calendar__more__link">${language(
					"ACTIVITY_SEE_ALL",
				)} <span class="material-icons-outlined notranslate calendar__more__icon">&#xE5C8;</span></a>`;
			}

			if (nofItems === 0) {
				calendar = "Ingen oppføringer funnet.";
				more = "";
				content = `<div class="calendar"></div>`;
			} else{
				let bgStyle = '';
				if (design.includes("background:")) {
					const color = design.split("background:")[1].trim();
					bgStyle = color !== "" ? `style="--current_calendar_bgcolor: ${color};"` : "";
					design = "background";
				}
				
				content = `
            <div class="calendar${design !== "" ? ` ${design}` : ''}" ${bgStyle}>
                <div class="calendar__head__row"><h2 class="calendar__title">${moduleTitle !== undefined ? moduleTitle : language("START_CALENDAR")}</h2></div>
                <div class="calendar__grid">
                  ${calendar}
                </div>
                  ${links}
                <div class="text-right">
                  <div class="calendar__more__container">
                    ${more}
                  </div>
                </div>
            </div>`;
			}

			$("#calendarlist__frontpage").html(content);
		}
	});

	return '<div id="calendarlist__frontpage" class="module__calendar"></div>';
};

export const xcalendarpage = () => {
	const list = xsetCalendarList();
	return `
        <div class="calendarlist__page" id="calendarlistcontainer">
            ${list}
        </div>`;
};

export const xsetCalendarList = (_from, _loadNum) => {
	// const breadcrumbHtml = breadcrumb();
	const loadNum = _loadNum || 10;
	const from = _from || 0;

	getCalendar({ load: loadNum, from: from }, (result) => {
		const availablecalendar = result.totalCount;
		const to = loadNum + from;
		let calendarList = [];

		$.each(result.listOfContent, (a, b) => {
			const date = new Date(b.firstCreated);
			const pDate = `${`0${date.getDate()}`.slice(-2)}-${`0${date.getMonth() + 1}`.slice(-2)}-${date.getFullYear()}`;
			const meta = JSON.parse(decodeURIComponent(b.metaObject));
			let img = "";
			const width = "col-sm-9";

			if (meta.imageContentId !== undefined && meta.imageContentId.length > 0) {
				const imgId = createGuid();
				img = `
                    <div class="col-sm-3 image__container">
                        <img src="" alt="" class="article__introimage" id="${imgId}" >
                    </div>`;

				getImageByContentId(meta.imageContentId, (img) => {
					if (img.url !== undefined && img.url.length > 0) {
						$(`#${imgId}`).attr("src", img.url);
					}
				});
			}

			// console.log("test before push");
			calendarList.push(`
                <div class="calendarlist__item">
                    <div class="row">
                        <a href = "/article/${b.contentId}" class = "calendarlist__link" >
                            ${img}
                            <div class="${width}">
                                <div class="calendarlist__content">
                                    <h3 class="calendarlist__header">
                                        ${b.title}
                                    </h3>
                                    <p class="calendarlist__intro">${b.intro}</p>
                                    <div class="calendarlist__date">${pDate}</div>
                                </div>
                            </div> 
                        </a>
                    </div>
                </div>`);
		});

		// $("#currentPageBreadcrumb").text(document.title);
		calendarList = calendarList.join("");

		$(".calendarlist__list").append(calendarList);
		const calendarlistHeader = `
            <div class="row">
                <div class="col mt-5">
                    <p>
                        Viser nyhet ${from + 1} til ${availablecalendar > to ? to : availablecalendar} av ${availablecalendar}
                    </p>
                </div>
            </div>`;

		$(".calendarlist__info").html(calendarlistHeader);
		if (availablecalendar > loadNum) {
			const pages = Math.ceil(availablecalendar / loadNum);
			let pageslinks = [];
			let i = 0;

			for (i = 0; i < pages; i++) {
				pageslinks.push(`
                    <li class="page-item ${i * loadNum === from ? "disabled" : ""}"><a class="page-link calendar__page__links " href="#" data-from="${i * loadNum
					}" >${i + 1}</a></li>`);
			}

			pageslinks = pageslinks.join("");
			const calendarlistFooter = `
                <div class="row">
                    <div class="col mt-5">
                        <nav aria-label="Bla i sider">
                          <ul class="pagination  pagination-lg">
                            ${pageslinks}
                          </ul>
                        </nav>
                    </div>
                </div>`;

			$(".calendarlist__footer").html(calendarlistFooter);
		}
	});

	$("body").off("click", ".calendar__page__links");
	$("body").on("click", ".calendar__page__links", function (e) {
		e.preventDefault();
		const num = $(this).data("from");
		setCalendarList(Number.parseInt(num));
		// $(window).scrollTo(0);
	});

	const listcontainer = `
        <div class="container">
            <div class="row">
                <div class="calendarlist col">
                    <h1 class="page__header">Nyheter</h1>
                    <div class="calendarlist__info"></div>
                    <div class="calendarlist__list"></div>
                    <div class="calendarlist__footer"></div>
                </div>
            </div>
        </div>`;

	$("#calendarlistcontainer").html(listcontainer);
	return listcontainer;
};

export const setLinkList = (links) => {
	if (links === undefined || links === "") {
		return "";
	}
	const linksArray = links.split(";").map((x) => x.replace("}", "").split("{"));
	const linksRow = [];
	for (const item of linksArray) {
		let icon = "arrow_forward";
		let target = "";
		if (item[1]?.includes("://")) {
			icon = "open_in_new";
			target = "_blank";
		}
		const link = `
            <div class="calendar__grid__links">
                <a class="buttonrow__button" href="${item[1]}" target="${target}" rel="noopener noreferrer">
                    ${item[0]}
                    <span class="material-icons-outlined notranslate buttonrow__button__icon">${icon}</span>
                </a>
            </div>`;
		linksRow.push(link);
	}
	if (linksRow.length === 1) {
		linksRow.push("<div></div>");
	}
	return linksRow.join("");
};
